import joanOroConfig from './config.joanoro';
import castellarnauConfig from './config.castellarnau';
import cavallbernatConfig from './config.cavallbernat';
import pompeuFabraConfig from './config.pompeufabra';
import jaumeMimoConfig from './config.jaumemimo';
import artLaIndustrialConfig from './config.artlaindustrial';
import iBadiaConfig from './config.ibadia';
import santaEulaliaConfig from './config.santaeulalia';
import demoConfig from './config.demo';

function getConfigByDomain()
{
    const domain = window.location.hostname;
    let config 

    switch (domain) {
        case 'matricula.institutjoanoro.cat':
            config = joanOroConfig
            config.develop = false;
            break;
        case 'matricula.institutcastellarnau.cat':
            config = castellarnauConfig
            config.develop = false;
            break;
        case 'matricula.inscavallbernat.cat':
            config = cavallbernatConfig
            config.develop = false;
            break;
        case 'matricula.iespompeufabra.cat':
            config = pompeuFabraConfig 
            config.develop = false;
            break;
        case 'matricula.insjaumemimo.cat':
            config = jaumeMimoConfig 
            config.develop = false;
            break;
        case 'matricula.artlaindustrial.cat':
            config = artLaIndustrialConfig 
            config.develop = false;
            break;
        case 'matricula.ibadia.cat':
            config =  iBadiaConfig
            config.develop = false;
            break;
        case 'matricula.santaeulalia.cat':
            config =  santaEulaliaConfig
            config.develop = false;
            break;
        case 'matricula.dieres.com':
            config = demoConfig
            config.develop = true;
            break;
        default:
            config = pompeuFabraConfig
            config = castellarnauConfig
            config = jaumeMimoConfig
            config = santaEulaliaConfig
            config = artLaIndustrialConfig  
            config = cavallbernatConfig
            config = demoConfig
            config = joanOroConfig
            
            config.develop = true;
            //config.develop = false;
            break;
    }

    return config;
}


export default getConfigByDomain()